import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles((theme) => ({
    contentWrapper: {
        padding: theme.spacing(2),
        position: 'fixed',
        top: 72,
        left: 0,
        right: 0,
        bottom: 64,
        overflow: 'auto',
    },
}));

export { useStyles };
